import React, {useState} from 'react';

import PropTypes from 'prop-types';
import {Tr, Td} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import {getFormattedDate} from '../utils/utils';
import {LinkButton} from "../design/css";

const Row = ({defect, index, selectedDefect, openModal}) => {
    const {
        defectWebform = '',
        defectCategory = '',
        updatedAt = '',
        name = '',
        priority = '',
        status = ''
    } = defect || {};

    return (
        <Tr style={{background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'}}>
            <Td style={{borderRight: '1px solid #e7e7e7'}}>
                {getFormattedDate(updatedAt, 'YYYY-MM-DD') || '-'}
            </Td>
            <Td style={{borderRight: '1px solid #e7e7e7'}}>{defectWebform}</Td>
            <Td style={{borderRight: '1px solid #e7e7e7'}}>{name}</Td>
            <Td style={{borderRight: '1px solid #e7e7e7'}}>{defectCategory}</Td>
            <Td style={{borderRight: '1px solid #e7e7e7'}}>{priority}</Td>
            <Td style={{borderRight: '1px solid #e7e7e7'}}>{status}</Td>
            <Td style={{borderRight: '1px solid #e7e7e7'}}>
                <LinkButton onClick={() => {
                    selectedDefect(defect);
                    openModal(true);
                }}>View</LinkButton>
            </Td>
        </Tr>
    );
};

Row.propTypes = {
    defect: PropTypes.objectOf(PropTypes.object).isRequired,
    index: PropTypes.number.isRequired,
    selectedDefect: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired
};

export default Row;
